import MadathaKhaja from "../assets/sweets/MadathaKhaja.png";
import Badusha from "../assets/sweets/Badusha.png";
import BellamGavvalu from "../assets/sweets/BellamGavvalu.png";
import DryFruitPootharekulu from "../assets/sweets/DryFruitPootharekulu.png";
import GorimitiPanchadara from "../assets/sweets/GorimitiPanchadara.png";
import Jahangir from "../assets/sweets/Jahangir.png";
import MotichoorLadoo from "../assets/sweets/MotichoorLadoo.png";
import MysorePak from "../assets/sweets/MysorePak.png";
import PanchadaraKommulu from "../assets/sweets/PanchadaraKommulu.png";
import PeddaBoondiAchu from "../assets/sweets/PeddaBoondiAchu.png";
import PeddaBoondiLaddu from "../assets/sweets/PeddaBoondiLaddu.png";
import SunnundaluBellam from "../assets/sweets/SunnundaluBellam.png";
import GottamKhaja from "../assets/sweets/GottamKhaja.png";
import Jelabi from "../assets/sweets/Jelabi.png";
import GulabJamun from "../assets/sweets/GulabJamun.png";
import KalaJamun from "../assets/sweets/KalaJamun.png";
import WhiteRasgulla from "../assets/sweets/WhiteRasgulla.png";
import PinkRasgulla from "../assets/sweets/PinkRasgulla.png";
import WhiteRaskadha from "../assets/sweets/WhiteRaskadha.png";
import DryFruitLadoo from "../assets/sweets/DryFruitLadoo.png";
import GheeMysorePak from "../assets/sweets/GheeMysorePak.png";
import MixedKalakand from "../assets/sweets/MixedKalakand.png";
import BrownKalakand from "../assets/sweets/BrownKalakand.png";
import IceCreamBarfi from "../assets/sweets/IceCreamBarfi.png";
import PalaKova from "../assets/sweets/PalaKova.png";
import DiamondKova from "../assets/sweets/DiamondKova.png";
import SoanPapidi from "../assets/sweets/SoanPapidi.png";
import BesanLadoo from "../assets/sweets/BesanLadoo.png";
import ThakkuduLadoo from "../assets/sweets/ThakkuduLadoo.png";
import Halwa from "../assets/sweets/Halwa.png";
import SugarPoothaRekulu from "../assets/sweets/SugarPoothaRekulu.png";

export const sweetsData = [
  {
    name: "Madatha Khaja",
    nameTe: "మడత ఖాజా",
    desc: "Khaja is basically Layered fritters made of maida flour and dunked in sugar syrup. The layering gives the sweet its desired flakiness. No festival is complete without this mouth-watering sweet in Andhra.",
    descTe: "ఖాజా అంటే మైదా పిండితో తయారు చేసిన పొరలు పొరలుగా ఉండే వేపుడు తీపి పదార్థం, పంచదార పాకంలో ముంచబడుతుంది. ఈ పొరలు తీపికి కావలసిన పొరలుదనాన్ని ఇస్తాయి. ఆంధ్రాలో ఏ పండుగైనా ఈ నోరూరించే తీపి లేకుండా పూర్తికాదు.",
    price: 200,
    quantity: "1 kg",
    image: MadathaKhaja,
  },
  {
    name: "Kakinada Gottam Khaja",
    nameTe: "కాకినాడ గొట్టం ఖాజా",
    desc: "Kakinada Gottam Khaja is a traditional sweet from Kakinada, Andhra Pradesh. Known for its crispy, flaky texture and cylindrical shape, it's made from wheat flour, sugar, and ghee. The dough is deep-fried and soaked in sugar syrup, creating a light, airy, and sweet delicacy cherished by locals and visitors alike.",
    descTe: "కాకినాడ గొట్టం ఖాజా ఆంధ్రప్రదేశ్‌లోని కాకినాడకు చెందిన సాంప్రదాయ తీపి పదార్థం. గోధుమ పిండి, పంచదార మరియు నెయ్యితో తయారు చేసే ఈ తీపి కమ్మని, పొరలు పొరలుగా ఉండే ఆకృతికి మరియు స్థూపాకారానికి ప్రసిద్ధి. పిండిని నూనెలో వేయించి పంచదార పాకంలో నానబెట్టడం వల్ల తేలికైన, గాలిలాంటి తీపి రుచి వస్తుంది, ఇది స్థానికులు మరియు సందర్శకులు ఇద్దరూ ఇష్టపడతారు.",
    price: 240,
    quantity: "1 kg",
    image: GottamKhaja,
  },
  {
    name: "Badusha",
    nameTe: "బాదుషా",
    desc: "A melt-in-your-mouth Indian sweet, deep-fried to golden perfection, soaked in sugar syrup, and adorned with a sprinkle of pistachios for a delightful treat",
    descTe: "నోట్లో వేసుకోగానే కరిగిపోయే ఈ భారతీయ తీపిని బంగారు రంగు వచ్చేవరకు వేయించి, పంచదార పాకంలో నానబెట్టి, పైన పిస్తా పలుకులతో అలంకరిస్తారు",
    price: 260,
    quantity: "1 kg",
    image: Badusha,
  },
  {
    name: "Bellam Gavvalu",
    nameTe: "బెల్లం గవ్వలు",
    desc: "Crispy, shell-shaped treats made with jaggery, combining the sweet allure of caramelized sugar with the delightful crunch of these traditional South Indian confections",
    descTe: "బెల్లంతో తయారు చేసిన గవ్వ ఆకారంలో ఉండే కరకరలాడే తీపి పదార్థం, కాల్చిన పంచదార తీపిదనాన్ని ఈ సాంప్రదాయ దక్షిణ భారత తినుబండారాల కరకరలాడే రుచితో మిళితం చేస్తుంది",
    price: 240,
    quantity: "1 kg",
    image: BellamGavvalu,
  },
  {
    name: "Dry Fruit Pootharekulu",
    nameTe: "డ్రై ఫ్రూట్ పూతరేకులు",
    desc: "Delectable confectionary delights, combining the richness of dry fruits with the traditional charm of Pootharekulu",
    descTe: "డ్రై ఫ్రూట్స్ యొక్క గొప్పదనాన్ని పూతరేకుల సాంప్రదాయ మాధుర్యంతో మిళితం చేసే రుచికరమైన తీపి పదార్థం",
    price: 800,
    quantity: "1 kg",
    image: DryFruitPootharekulu,
  },
  {
    name: "Sugar Dry Fruit Pootharekulu",
    nameTe: "షుగర్ పూతరేకులు",
    desc: "Sugar Pootha Rekulu is a traditional Andhra Pradesh dessert consisting of layered rice crepes filled with a mixture of ghee, sugar, and cardamom powder. It's known for its delicate layers and sweet, aromatic filling, making it a favorite during festive celebrations.",
    descTe: "షుగర్ పూతరేకులు అనేది నెయ్యి, పంచదార మరియు ఏలకుల పొడి మిశ్రమంతో నింపిన పొరలు పొరలుగా ఉండే బియ్యపు రేకులతో కూడిన సాంప్రదాయ ఆంధ్రప్రదేశ్ తీపి పదార్థం. దీని సున్నితమైన పొరలు మరియు తీపి, సుగంధభరితమైన నింపకానికి ప్రసిద్ధి, పండుగల సమయంలో ఇది ఇష్టమైన తినుబండారం.",
    price: 800,
    quantity: "1 kg",
    image: SugarPoothaRekulu,
  },
  {
    name: "Gorimiti Panchadara",
    nameTe: "గోరుమిటి పంచదార",
    desc: "A sweet and savory South Indian delight, showcasing the perfect blend of jaggery sweetness and spicy flavors in a crispy, golden-brown treat",
    descTe: "బెల్లం తీపిదనం మరియు కారంగా ఉండే రుచుల సమతుల్యతను కరకరలాడే, బంగారు-గోధుమ రంగు తినుబండారంలో చూపించే తీపి మరియు కారం కలగలిపిన దక్షిణ భారత రుచి",
    price: 260,
    quantity: "1 kg",
    image: GorimitiPanchadara,
  },
  {
    name: "Jahangir",
    nameTe: "జహంగీర్",
    desc: "An exquisite Mughlai-inspired sweet, named after the legendary emperor, featuring layers of rich khoya, nuts, and saffron, creating a regal indulgence for the palate",
    descTe: "గొప్ప ఖోయా, డ్రై ఫ్రూట్స్ మరియు కుంకుమపువ్వు పొరలతో కూడిన, ప్రఖ్యాత చక్రవర్తి పేరు పెట్టబడిన ఒక అద్భుతమైన మొఘలాయి తరహా తీపి, ఇది నాలుకకు రాజసమైన అనుభూతిని ఇస్తుంది",
    price: 300,
    quantity: "1 kg",
    image: Jahangir,
  },
  {
    name: "Motichur Laddu",
    nameTe: "మోతిచూర్ లడ్డు",
    desc: "Miniature golden orbs of sweetness, crafted from fine chickpea flour, fried to perfection, and delicately coated in sugar syrup, offering a classic Indian treat.",
    descTe: "సున్నితమైన శనగపిండితో తయారు చేసిన బంగారు రంగు చిన్న బూందీలు, వేయించి, పంచదార పాకంలో మెత్తగా పూత పూయబడి, ఒక క్లాసిక్ భారతీయ తీపిని అందిస్తాయి.",
    price: 300,
    quantity: "1 kg",
    image: MotichoorLadoo,
  },
  {
    name: "Mysore Pak",
    nameTe: "మైసూర్ పాక్",
    desc: "A South Indian delicacy renowned for its crumbly texture and rich flavor, blending ghee, besan (gram flour), and sugar into a delectable confection that melts in the mouth",
    descTe: "నెయ్యి, శనగపిండి మరియు పంచదారను కలిపి నోట్లో కరిగిపోయే రుచికరమైన తీపిగా మార్చే, పెళుసైన ఆకృతికి మరియు గొప్ప రుచికి ప్రసిద్ధి చెందిన దక్షిణ భారత ప్రత్యేకత",
    price: 300,
    quantity: "1 kg",
    image: MysorePak,
  },
  {
    name: "Panchadara Kommulu",
    nameTe: "పంచదార కొమ్ములు",
    desc: "These sweet delights, named for their fivefold sweetness, feature a harmonious blend of jaggery, coconut, and other flavors, creating a delectable treat with a touch of tradition",
    descTe: "ఐదు రెట్లు తీపిదనం పేరుతో పిలువబడే ఈ తీపి పదార్థాలు, బెల్లం, కొబ్బరి మరియు ఇతర రుచుల సమతుల్య మిశ్రమంతో సాంప్రదాయ స్పర్శతో కూడిన రుచికరమైన తినుబండారాన్ని అందిస్తాయి",
    price: 240,
    quantity: "1 kg",
    image: PanchadaraKommulu,
  },
  {
    name: "Pedda Boondi Achu",
    nameTe: "పెద్ద బూంది అచ్చు",
    desc: "Tiny, golden-hued spheres of sweetness, skillfully crafted from besan (gram flour) and adorned with a hint of cardamom, presenting a delightful South Indian confection",
    descTe: "శనగపిండితో నేర్పుగా తయారు చేసిన చిన్న, బంగారు రంగు గోళాకార తీపి బిళ్ళలు, కొద్దిగా ఏలకుల రుచితో అలంకరించబడి, ఒక అద్భుతమైన దక్షిణ భారత తినుబండారాన్ని అందిస్తాయి",
    price: 280,
    quantity: "1 kg",
    image: PeddaBoondiAchu,
  },
  {
    name: "Pedda Boondi Laddu",
    nameTe: "పెద్ద బూంది లడ్డు",
    desc: "Irresistible spheres of sweet indulgence, combining tiny boondis with ghee, sugar syrup, and a touch of cardamom, creating a classic and flavorful Indian treat",
    descTe: "చిన్న బూందీలను నెయ్యి, పంచదార పాకం మరియు ఏలకుల స్పర్శతో కలిపి తయారు చేసే, ఆకర్షణీయమైన తీపి గోళాలు, ఒక క్లాసిక్ మరియు రుచికరమైన భారతీయ తినుబండారాన్ని సృష్టిస్తాయి",
    price: 280,
    quantity: "1 kg",
    image: PeddaBoondiLaddu,
  },
  {
    name: "Sunnundalu Bellam",
    nameTe: "సున్నుండలు బెల్లం",
    desc: "Wholesome and nutritious, these laddus feature roasted urad dal flour combined with jaggery, forming delectable balls that celebrate the richness of tradition and simplicity",
    descTe: "వేయించిన మినప్పప్పు పిండిని బెల్లంతో కలిపి తయారు చేసే ఈ లడ్డులు, పోషకాహారంతో నిండి ఉంటాయి, సంప్రదాయం మరియు సరళత యొక్క గొప్పదనాన్ని జరుపుకునే రుచికరమైన ఉండలను ఏర్పరుస్తాయి",
    price: 600,
    quantity: "1 kg",
    image: SunnundaluBellam,
  },
  {
    name: "Jelabi",
    nameTe: "జిలేబి",
    desc: "Jelabi is a South Indian sweet made from jaggery, sugar, and ghee. It's a delicious treat that can be enjoyed in a variety of ways, including as a snack or as a dessert",
    descTe: "జిలేబి అనేది బెల్లం, పంచదార మరియు నెయ్యితో తయారు చేసిన దక్షిణ భారత తీపి పదార్థం. ఇది స్నాక్‌గా లేదా డెజర్ట్‌గా అనేక రకాలుగా ఆస్వాదించదగిన రుచికరమైన తినుబండారం",
    price: 200,
    quantity: "1 kg",
    image: Jelabi,
  },
  {
    name: "Gulab Jamun",
    nameTe: "గులాబ్ జామూన్",
    desc: "Gulab Jamun is a popular Indian dessert made from deep-fried milk solids, soaked in a fragrant sugar syrup flavored with cardamom and rose water. These soft, spongy balls are often enjoyed warm and are a staple at festive occasions and celebrations.",
    descTe: "గులాబ్ జామూన్ అనేది పాల ఘనపదార్థాలను నూనెలో వేయించి, ఏలకులు మరియు గులాబ్ నీటి రుచితో కూడిన సుగంధభరిత పంచదార పాకంలో నానబెట్టిన ఒక ప్రసిద్ధ భారతీయ డెజర్ట్. ఈ మెత్తని, స్పాంజిలాంటి ఉండలను వేడిగా ఆస్వాదిస్తారు, ఇవి పండుగలు మరియు వేడుకలలో ప్రధానమైనవి.",
    price: 300,
    quantity: "1 kg",
    image: GulabJamun,
  },
  {
    name: "Kala Jamun",
    nameTe: "కళా జామూన్",
    desc: "Kala Jamun is a dark-colored variant of the traditional Indian dessert Gulab Jamun, made from deep-fried milk solids and soaked in a sugar syrup flavored with cardamom and rose water. Its distinct dark hue and slightly denser texture make it a unique and beloved treat at festive occasions.",
    descTe: "కళా జామూన్ అనేది సాంప్రదాయ గులాబ్ జామూన్ యొక్క ముదురు రంగు రూపాంతరం, పాల ఘనపదార్థాలను నూనెలో వేయించి, ఏలకులు మరియు గులాబ్ నీటి రుచితో కూడిన పంచదార పాకంలో నానబెట్టి తయారు చేస్తారు. దీని ప్రత్యేకమైన ముదురు రంగు మరియు కొంచెం గట్టి ఆకృతి పండుగల సమయంలో దీన్ని ఒక ప్రత్యేకమైన మరియు ఇష్టమైన తినుబండారంగా చేస్తాయి.",
    price: 300,
    quantity: "1 kg",
    image: KalaJamun,
  },
  {
    name: "White Rasgulla",
    nameTe: "వైట్ రసగుల్ల",
    desc: "White Rasgulla is a classic Indian dessert consisting of soft, spongy balls made from chhena (Indian cottage cheese) and semolina, soaked in a light sugar syrup. Renowned for its delicate texture and mildly sweet flavor, it is a favorite treat across India.",
    descTe: "వైట్ రసగుల్ల అనేది చెన్నా (పన్నీర్) మరియు రవ్వతో తయారు చేసిన మెత్తని, స్పాంజిలాంటి ఉండలతో కూడిన ఒక క్లాసిక్ భారతీయ డెజర్ట్, తేలికపాటి పంచదార పాకంలో నానబెట్టబడుతుంది. దీని సున్నితమైన ఆకృతి మరియు మృదువైన తీపి రుచికి భారతదేశం అంతటా ఇష్టమైన తినుబండారం.",
    price: 300,
    quantity: "1 kg",
    image: WhiteRasgulla,
  },
  {
    name: "Pink Rasgulla",
    nameTe: "పింక్ రసగుల్ల",
    desc: "Pink Rasgulla is a delightful twist on the classic Indian dessert, featuring soft, spongy balls made from chhena (Indian cottage cheese) and semolina, soaked in a rose-flavored pink sugar syrup. Its vibrant color and fragrant sweetness make it a festive favorite.",
    descTe: "పింక్ రసగుల్ల అనేది క్లాసిక్ భారతీయ డెజర్ట్‌కు ఒక అందమైన మలుపు, చెన్నా మరియు రవ్వతో తయారు చేసిన మెత్తని ఉండలను గులాబ్ రుచి గల పింక్ పంచదార పాకంలో నానబెట్టి తయారు చేస్తారు. దీని ప్రకాశవంతమైన రంగు మరియు సుగంధభరిత తీపిదనం దీన్ని పండుగల ఇష్టమైన తినుబండారంగా చేస్తాయి.",
    price: 300,
    quantity: "1 kg",
    image: PinkRasgulla,
  },
  {
    name: "White Raskadha",
    nameTe: "వైట్ రస్‌కదా",
    desc: "White Raskadha is a rich Indian dessert made from creamy chhena (Indian cottage cheese) and khoya (dried milk), shaped into soft, delicate balls. These are soaked in a mildly sweet, thickened milk syrup, offering a luxurious and indulgent treat.",
    descTe: "వైట్ రస్‌కదా అనేది క్రీమీ చెన్నా మరియు ఖోయాతో తయారు చేసిన ఒక గొప్ప భారతీయ డెజర్ట్, మెత్తని, సున్నితమైన ఉండల ఆకారంలో తయారు చేయబడుతుంది. వీటిని తేలికపాటి తీపి, చిక్కబడిన పాల పాకంలో నానబెట్టడం వల్ల ఒక విలాసవంతమైన రుచి లభిస్తుంది.",
    price: 300,
    quantity: "1 kg",
    image: WhiteRaskadha,
  },
  {
    name: "Dry Fruit Ladoo",
    nameTe: "డ్రై ఫ్రూట్ లడ్డు",
    desc: "Dry Fruit Ladoo is a nutritious Indian sweet made from a mix of finely chopped nuts, dried fruits, and seeds, bound together with ghee and natural sweeteners like jaggery or dates. These energy-packed treats are both delicious and healthy, often enjoyed during festivals and special occasions.",
    descTe: "డ్రై ఫ్రూట్ లడ్డు అనేది సన్నగా తరిగిన డ్రై ఫ్రూట్స్, గింజల మిశ్రమాన్ని నెయ్యి మరియు బెల్లం లేదా ఖర్జూరం వంటి సహజ తీపి పదార్థాలతో కలిపి తయారు చేసే పోషకాహారం గల భారతీయ తీపి. ఈ శక్తినిచ్చే తినుబండారాలు రుచికరమైనవి మరియు ఆరోగ్యకరమైనవి, పండుగలు మరియు ప్రత్యేక సందర్భాలలో వీటిని ఆస్వాదిస్తారు.",
    price: 760,
    quantity: "1 kg",
    image: DryFruitLadoo,
  },
  {
    name: "Ghee Mysore Pak",
    nameTe: "నెయ్యి మైసూర్ పాక్",
    desc: "Ghee Mysore Pak is a rich and decadent South Indian sweet made from gram flour, sugar, and an abundance of ghee. Known for its melt-in-the-mouth texture and aromatic flavor, it is a beloved delicacy, especially during festivals and celebrations.",
    descTe: "నెయ్యి మైసూర్ పాక్ అనేది శనగపిండి, పంచదార మరియు పుష్కలంగా నెయ్యితో తయారు చేసిన ఒక గొప్ప మరియు రుచికరమైన దక్షిణ భారత తీపి. నోట్లో కరిగిపోయే ఆకృతికి మరియు సుగంధభరిత రుచికి ప్రసిద్ధి చెందిన ఇది, ప్రత్యేకించి పండుగలు మరియు వేడుకలలో ఇష్టమైన తినుబండారం.",
    price: 600,
    quantity: "1 kg",
    image: GheeMysorePak,
  },
  {
    name: "Mixed Kalakand",
    nameTe: "మిక్స్డ్ కలాకంద్",
    desc: "Mixed Kalakand is a delightful Indian dessert combining the richness of condensed milk with paneer (Indian cottage cheese), flavored with cardamom and garnished with nuts. Its creamy texture and sweet, aromatic taste make it a popular choice for festive occasions.",
    descTe: "మిక్స్డ్ కలాకంద్ అనేది కండెన్స్డ్ మిల్క్ యొక్క గొప్పదనాన్ని పన్నీర్‌తో కలిపి, ఏలకుల రుచితో మరియు గింజలతో అలంకరించిన ఒక అద్భుతమైన భారతీయ డెజర్ట్. దీని క్రీమీ ఆకృతి మరియు తీపి, సుగంధభరిత రుచి పండుగల సందర్భాలకు ఇష్టమైన ఎంపికగా చేస్తాయి.",
    price: 600,
    quantity: "1 kg",
    image: MixedKalakand,
  },
  {
    name: "Brown Kalakand",
    nameTe: "బ్రౌన్ కలాకంద్",
    desc: "Brown Kalakand is a variation of the traditional Indian sweet, made with condensed milk and paneer, cooked until it caramelizes to a rich brown color. Its intense flavor and slightly chewy texture distinguish it as a decadent treat enjoyed on special occasions.",
    descTe: "బ్రౌన్ కలాకంద్ అనేది సాంప్రదాయ భారతీయ తీపి యొక్క ఒక రూపాంతరం, కండెన్స్డ్ మిల్క్ మరియు పన్నీర్‌తో తయారు చేసి, గొప్ప గోధుమ రంగు వచ్చేవరకు కాల్చబడుతుంది. దీని బలమైన రుచి మరియు కొద్దిగా నమలగలిగే ఆకృతి దీన్ని ప్రత్యేక సందర్భాలలో ఆస్వాదించే ఒక విలాసవంతమైన తినుబండారంగా చేస్తాయి.",
    price: 600,
    quantity: "1 kg",
    image: BrownKalakand,
  },
  {
    name: "Ice cream Barfi",
    nameTe: "ఐస్‌క్రీమ్ బర్ఫీ",
    desc: "Ice Cream Barfi is a fusion dessert that combines the creamy richness of traditional Indian barfi with the coolness of ice cream. It offers a delightful blend of flavors and textures, making it a refreshing treat for dessert lovers.",
    descTe: "ఐస్‌క్రీమ్ బర్ఫీ అనేది సాంప్రదాయ భారతీయ బర్ఫీ యొక్క క్రీమీ గొప్పదనాన్ని ఐస్‌క్రీమ్ యొక్క చల్లదనంతో మిళితం చేసే ఒక సమ్మేళన డెజర్ట్. ఇది రుచులు మరియు ఆకృతుల అద్భుతమైన మిశ్రమాన్ని అందిస్తుంది, డెజర్ట్ ప్రియులకు ఇది ఒక ఉత్తేజకరమైన తినుబండారం.",
    price: 600,
    quantity: "1 kg",
    image: IceCreamBarfi,
  },
  {
    name: "Pala Kova",
    nameTe: "పాల కోవా",
    desc: "Pala kova is a traditional South Indian sweet made by simmering milk until it reduces to a creamy, fudge-like consistency, often flavored with cardamom and garnished with nuts. Its rich, milky flavor and smooth texture make it a cherished delicacy during festivals and celebrations.",
    descTe: "పాల కోవా అనేది పాలను క్రీమీ, ఫడ్జ్ లాంటి గాఢతకు వచ్చేవరకు మరిగించి తయారు చేసే సాంప్రదాయ దక్షిణ భారత తీపి, తరచుగా ఏలకుల రుచితో మరియు గింజలతో అలంకరించబడుతుంది. దీని గొప్ప, పాల రుచి మరియు మృదువైన ఆకృతి పండుగలు మరియు వేడుకల సమయంలో ఇష్టమైన తినుబండారంగా చేస్తాయి.",
    price: 440,
    quantity: "1 kg",
    image: PalaKova,
  },
  {
    name: "Diamond Kova",
    nameTe: "డైమండ్ కోవా",
    desc: "Diamond Kova is a sweet delicacy originating from South India, made by reducing milk until it forms a thick, solid consistency and then cut into diamond-shaped pieces. Known for its creamy texture and rich flavor, it is a popular treat enjoyed during festive occasions.",
    descTe: "డైమండ్ కోవా అనేది దక్షిణ భారతదేశం నుండి వచ్చిన ఒక తీపి పదార్థం, పాలను చిక్కటి, ఘనమైన గాఢతకు వచ్చేవరకు మరిగించి, తర్వాత వజ్రం ఆకారంలో ముక్కలుగా కోస్తారు. దీని క్రీమీ ఆకృతి మరియు గొప్ప రుచికి ప్రసిద్ధి చెందిన ఇది, పండుగల సందర్భాలలో ఆస్వాదించే ఒక ప్రసిద్ధ తినుబండారం.",
    price: 400,
    quantity: "1 kg",
    image: DiamondKova,
  },
  {
    name: "Soan Papidi",
    nameTe: "సోన్ పాపిడి",
    desc: "Soan Papdi is a popular Indian dessert known for its flaky, melt-in-your-mouth texture and sweet flavor, often flavored with cardamom and garnished with almonds or pistachios. It is enjoyed as a light and crispy treat during festivals and celebrations.",
    descTe: "సోన్ పాప్డీ అనేది పొరలు పొరలుగా, నోట్లో కరిగిపోయే ఆకృతికి మరియు తీపి రుచికి ప్రసిద్ధి చెందిన ఒక ప్రసిద్ధ భారతీయ డెజర్ట్, తరచుగా ఏలకుల రుచితో మరియు బాదం లేదా పిస్తాలతో అలంకరించబడుతుంది. పండుగలు మరియు వేడుకల సమయంలో దీన్ని తేలికైన మరియు కరకరలాడే తినుబండారంగా ఆస్వాదిస్తారు.",
    price: 300,
    quantity: "1 kg",
    image: SoanPapidi,
  },
  {
    name: "Besan Ladoo",
    nameTe: "బేసన్ లడ్డు",
    desc: "Besan Ladoo is a traditional Indian sweet made from roasted gram flour (besan), ghee, and sugar, shaped into round balls and garnished with nuts. These aromatic and mildly sweet treats are a favorite at festivals and special occasions.",
    descTe: "బేసన్ లడ్డు అనేది వేయించిన శనగపిండి, నెయ్యి మరియు పంచదారతో తయారు చేసిన సాంప్రదాయ భారతీయ తీపి, గుండ్రని ఉండలుగా తయారు చేసి గింజలతో అలంకరించబడుతుంది. ఈ సుగంధభరితమైన మరియు తేలికపాటి తీపి తినుబండారాలు పండుగలు మరియు ప్రత్యేక సందర్భాలలో ఇష్టమైనవి.",
    price: 300,
    quantity: "1 kg",
    image: BesanLadoo,
  },
  {
    name: "Thakkudu Ladoo",
    nameTe: "తక్కుడు లడ్డు",
    desc: "Thakkudu Ladoo is a popular South Indian sweet made from roasted gram flour (besan), ghee, and jaggery, molded into small, round balls. Known for its rich flavor and dense texture, it's a cherished treat often enjoyed during festivities and celebrations.",
    descTe: "తక్కుడు లడ్డు అనేది వేయించిన శనగపిండి, నెయ్యి మరియు బెల్లంతో తయారు చేసిన ఒక ప్రసిద్ధ దక్షిణ భారత తీపి, చిన్న, గుండ్రని ఉండలుగా తయారు చేస్తారు. దీని గొప్ప రుచి మరియు గట్టి ఆకృతికి ప్రసిద్ధి చెందిన ఇది, పండుగలు మరియు వేడుకల సమయంలో తరచుగా ఆస్వాదించే ఒక ఇష్టమైన తినుబండారం.",
    price: 300,
    quantity: "1 kg",
    image: ThakkuduLadoo,
  },
  {
    name: "Halwa",
    nameTe: "హల్వా",
    desc: "Halwa is a sweet and dense dessert found across various cultures, made from ingredients like semolina (rava), carrots, or wheat flour, cooked with ghee, sugar, and often garnished with nuts or dried fruits. Its soft, pudding-like consistency and aromatic flavors make it a beloved treat for special occasions.",
    descTe: "హల్వా అనేది వివిధ సంస్కృతులలో కనిపించే తీపి మరియు గాఢమైన డెజర్ట్, రవ్వ, క్యారెట్లు లేదా గోధుమ పిండి వంటి పదార్థాలతో నెయ్యి, పంచదారతో వండి, తరచుగా గింజలు లేదా డ్రై ఫ్రూట్స్‌తో అలంకరించబడుతుంది. దీని మృదువైన, పుడ్డింగ్ లాంటి గాఢత మరియు సుగంధభరిత రుచులు ప్రత్యేక సందర్భాలకు ఇష్టమైన తినుబండారంగా చేస్తాయి.",
    price: 300,
    quantity: "1 kg",
    image: Halwa,
  },
];
